import TermsOfService from './components/TermsOfService';

export default function Terms() {
  return (
    <TermsOfService
      company='MV BUMPY GROUP LIMITED'
      address='Strovolou 77, Strovolos center, 4th floor, Flat/Office 401, Strovolos, 2018, Nicosia, Cyprus'
      privacyUrl='/privacy'
    />
  );
}
